import { Button, Icon } from '@smartgift/frontend-toolkit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { DownloadReport } from '@hero/components/modals';
import { CONTACT_TYPE, PRODUCT_TYPES } from '@hero/constants';
import { GiftSelection, RecipientEngagement, ThankYouNotes } from '@hero/organisms';
import { useGenerateRecognitionsDetailReport } from '@hero/services/analytic-service/hooks';
import { useGetCharities } from '@hero/services/merchant-service/hooks';
import {
  useGetRecognition,
  useGetRecognitionAcceptanceRate,
  useGetRecognitionPopularGifts
} from '@hero/services/order-service/recognition/hooks';

import * as SS from '../style';

import * as S from './style';

const AnalyticsDetail = ({ setActiveTab }) => {
  const { recognitionCode } = useParams();
  const { t } = useTranslation();
  const { data: recognition } = useGetRecognition({ recognitionCode });
  const { data: recognitionAcceptanceRate } = useGetRecognitionAcceptanceRate({
    recognitionCode
  });

  const { data: popularGifts } = useGetRecognitionPopularGifts(
    {
      pagination: {
        page: 1,
        limit: 50
      },
      filters: {
        ids: [recognition?.id]
      }
    },
    {
      enabled: !!recognition?.id
    }
  );

  const charityCodes = React.useMemo(() => {
    return popularGifts
      ?.filter(gift => gift.type === PRODUCT_TYPES.CHARITY)
      .map(gift => gift.merchantProductId);
  }, [popularGifts]);

  const { data: popularCharities } = useGetCharities({
    params: {
      filters: {
        keys: charityCodes
      }
    },
    options: {
      enabled: !!popularGifts?.length && !!charityCodes?.length
    }
  });

  const [isOpenDownloadReport, setIsOpenDownloadReport] = useState(false);
  const openDownloadReportHandler = () => {
    setIsOpenDownloadReport(true);
  };
  const closeDownloadReportHandler = () => {
    setIsOpenDownloadReport(false);
  };

  const { mutateAsync: mutateAsyncSentRecognitionReport } = useGenerateRecognitionsDetailReport();

  return (
    <S.AnalyticsWrapper>
      <SS.HeaderWrapper>
        <Button
          variant="text"
          onClick={openDownloadReportHandler}
          startIcon={<Icon name="download" />}
          disabled={recognitionAcceptanceRate?.acceptanceRates?.total === 0}
        >
          {t('downloadReport')}
        </Button>
        <DownloadReport
          isOpen={isOpenDownloadReport}
          onRequestClose={closeDownloadReportHandler}
          onAsyncSubmit={async data => {
            await mutateAsyncSentRecognitionReport({
              params: { id: recognitionCode },
              body: {
                emails: data.contacts.map(item => item.email).join(',')
              }
            });
          }}
        />
      </SS.HeaderWrapper>
      <S.Row>
        <RecipientEngagement
          analytics={recognitionAcceptanceRate}
          isContactLess={recognition?.contacts?.type === CONTACT_TYPE.number}
        />
        <GiftSelection
          products={recognition?.products}
          gifts={popularGifts || []}
          charities={popularCharities}
          analytics={recognitionAcceptanceRate}
          isContactLess={recognition?.contacts?.type === CONTACT_TYPE.number}
        />
      </S.Row>
      <ThankYouNotes
        appreciation={recognitionAcceptanceRate?.appreciationRates}
        style={{ width: 'calc(50% - 12px)' }}
        setActiveTab={setActiveTab}
      />
    </S.AnalyticsWrapper>
  );
};

export default AnalyticsDetail;
